import { useEffect, useState } from "react";
import { GameMediumContainer } from "../General/GameMediumContainer";
import { getTribesApi } from "../../services/warriorService";

export function Tribes(props) {
  const [tribes, setTribes] = useState([]);

  useEffect(() => {
    //console.log("change meta");
    document
      .querySelector('meta[property="og:title"]')
      .setAttribute("content", "Warrior Tale - Tribes");
    document
      .querySelector('meta[property="og:image"]')
      .setAttribute(
        "content",
        "https://warriortale.com/images/general/warlord.png"
      );
  }, []);

  useEffect(() => {
    getTribes();
    // getTribesApi().then((data) => {
    //   if(data){
    //     setTribes(data);
    //     document.querySelector('meta[property="og:title"]').setAttribute("content", "Warrior Tale - Tribe Informations");
    //   }
    // });
  }, []);

  function getTribes() {
    let tribeList = [
      {
        _id: {
          $oid: "64fd7057081fbaf089f3856f",
        },
        tribeName: "Bran",
        color: "2d6ed6",
        money: 0,
        prestige: 9,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "64fd7057081fbaf089f38570",
        },
        tribeName: "Kalmar",
        color: "8c5154",
        money: 0,
        prestige: 24,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "64fd7057081fbaf089f38571",
        },
        tribeName: "Kopen",
        color: "d62d8d",
        money: 0,
        prestige: 21,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "64fd7057081fbaf089f38572",
        },
        tribeName: "Herguz",
        color: "fcba03",
        money: 0,
        prestige: 27,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "6500aa18b24a09040ff88f8f",
        },
        tribeName: "Vazez",
        color: "cf271b",
        money: 0,
        prestige: 18,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "6500aa18b24a09040ff88f90",
        },
        tribeName: "Mugur",
        color: "cfc31b",
        money: 0,
        prestige: 21,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "6500aa18b24a09040ff88f91",
        },
        tribeName: "Nalgar",
        color: "566887",
        money: 0,
        prestige: 15,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "6500aa18b24a09040ff88f92",
        },
        tribeName: "Catuge",
        color: "453e3f",
        money: 0,
        prestige: 18,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "6500aa18b24a09040ff88f93",
        },
        tribeName: "Inora",
        color: "b4c6d9",
        money: 0,
        prestige: 18,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "6500aa18b24a09040ff88f94",
        },
        tribeName: "Calcar",
        color: "70102d",
        money: 0,
        prestige: 24,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "6500aa18b24a09040ff88f95",
        },
        tribeName: "Peter",
        color: "910901",
        money: 0,
        prestige: 27,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "6500aa18b24a09040ff88f96",
        },
        tribeName: "Ikora",
        color: "35a7d4",
        money: 0,
        prestige: 24,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "6500aa18b24a09040ff88f97",
        },
        tribeName: "Zucace",
        color: "176e31",
        money: 0,
        prestige: 24,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "6500aa18b24a09040ff88f98",
        },
        tribeName: "Kustaba",
        color: "320eab",
        money: 0,
        prestige: 27,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "6500aa18b24a09040ff88f99",
        },
        tribeName: "Enirk",
        color: "e0d910",
        money: 0,
        prestige: 24,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "6500aa19b24a09040ff88f9a",
        },
        tribeName: "Yobura",
        color: "bf3dac",
        money: 0,
        prestige: 21,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "6500aa19b24a09040ff88f9b",
        },
        tribeName: "Poznu",
        color: "7d8274",
        money: 0,
        prestige: 21,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "6500aa19b24a09040ff88f9c",
        },
        tribeName: "Hukra",
        color: "3e403d",
        money: 0,
        prestige: 30,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "6500aa19b24a09040ff88f9d",
        },
        tribeName: "Lugaru",
        color: "69855b",
        money: 0,
        prestige: 12,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "6500aa19b24a09040ff88f9e",
        },
        tribeName: "Garude",
        color: "4667a3",
        money: 0,
        prestige: 15,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "6500aa19b24a09040ff88f9f",
        },
        tribeName: "Agor",
        color: "a1b82e",
        money: 0,
        prestige: 18,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "6500aa19b24a09040ff88fa0",
        },
        tribeName: "Monez",
        color: "4bbd86",
        money: 0,
        prestige: 27,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "6500aa19b24a09040ff88fa1",
        },
        tribeName: "Rugi",
        color: "99405f",
        money: 0,
        prestige: 15,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "6500aa19b24a09040ff88fa2",
        },
        tribeName: "Okarte",
        color: "995353",
        money: 0,
        prestige: 24,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "6500aa19b24a09040ff88fa3",
        },
        tribeName: "Sansyo",
        color: "ba9434",
        money: 0,
        prestige: 24,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "6500aa19b24a09040ff88fa4",
        },
        tribeName: "Salgur",
        color: "bdc46a",
        money: 0,
        prestige: 21,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "6500aa19b24a09040ff88fa5",
        },
        tribeName: "Hepza",
        color: "5db82c",
        money: 0,
        prestige: 18,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "6500aa19b24a09040ff88fa6",
        },
        tribeName: "Ossa",
        color: "52bf87",
        money: 0,
        prestige: 15,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "6500aa19b24a09040ff88fa7",
        },
        tribeName: "Helus",
        color: "1c1fc7",
        money: 0,
        prestige: 27,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
      {
        _id: {
          $oid: "6500aa19b24a09040ff88fa8",
        },
        tribeName: "Tarkir",
        color: "6fc2e3",
        money: 0,
        prestige: 21,
        warlordId: "npc",
        warlordInfo: null,
        primaryWarbandOverall: 0,
        secondaryWarbandOverall: 0,
        firstWarbandPlanSend: false,
        firstWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
        secondWarbandDataList: [
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
        ],
      },
    ];
    let tribeList2 = [
      {
        id: 1,
        tribeName: "Bran",
        color: "2d6ed6",
        prestige: 9,
        warlordId: "npc",
        warlordInfo: { warlordName: "Npc" },
      },
      {
        id: 2,
        tribeName: "Kalmar",
        color: "8c5154",
        prestige: 24,
        warlordId: "npc",
        warlordInfo: { warlordName: "Npc" },
      },
      {
        id: 3,
        tribeName: "Kopen",
        color: "d62d8d",
        prestige: 21,
        warlordId: "npc",
        warlordInfo: { warlordName: "Npc" },
      },
      {
        id: 4,
        tribeName: "Herguz",
        color: "fcba03",
        prestige: 27,
        warlordId: "npc",
        warlordInfo: { warlordName: "Npc" },
      },
      {
        id: 5,
        tribeName: "Vazez",
        color: "cf271b",
        prestige: 2,
        warlordId: "npc",
        warlordInfo: { warlordName: "Npc" },
      },
      {
        id: 6,
        tribeName: "Mugur",
        color: "cfc31b",
        prestige: 5,
        warlordId: "npc",
        warlordInfo: { warlordName: "Npc" },
      },
      {
        id: 7,
        tribeName: "Nalgar",
        color: "566887",
        prestige: 8,
        warlordId: "npc",
        warlordInfo: { warlordName: "Npc" },
      },
      {
        id: 8,
        tribeName: "Catuge",
        color: "453e3f",
        prestige: 18,
        warlordId: "npc",
        warlordInfo: { warlordName: "Npc" },
      },
      {
        id: 9,
        tribeName: "Inora",
        color: "b4c6d9",
        prestige: 11,
        warlordId: "npc",
        warlordInfo: { warlordName: "Npc" },
      },
      {
        id: 10,
        tribeName: "Calcar",
        color: "70102d",
        prestige: 24,
        warlordId: "npc",
        warlordInfo: { warlordName: "Npc" },
      },
    ];
    setTribes(tribeList);
  }

  let rankingCounter = 0;
  let tribesTableRows = tribes.map((tribe) => {
    rankingCounter++;
    return (
      <tr key={tribe.id}>
        <th scope="row">{rankingCounter}</th>
        <td className="text-capitalize">
          <div className="d-flex align-items-center">
            <div>
              <span>
                <i
                  className="bi bi-octagon-fill"
                  style={{ color: `#${tribe.color}` }}
                ></i>
              </span>
            </div>
            <div className="ms-3">{tribe.tribeName}</div>
          </div>
        </td>
        <td className="general-table-td">{tribe.prestige}</td>
        <td className="general-table-td text-capitalize">
          {tribe.warlordId === "npc" ? "Npc" : tribe.warlordInfo?.warlordName}
        </td>
      </tr>
    );
  });

  return (
    <div>
      <GameMediumContainer innerContainer={props.innerContainer}>
        <h2>Tribes</h2>
        <div>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Tribe</th>
                <th scope="col">Prestige</th>
                <th scope="col">Warlord</th>
              </tr>
            </thead>
            <tbody>{tribesTableRows}</tbody>
          </table>
        </div>
      </GameMediumContainer>
    </div>
  );
}
